import { LinkByText } from '../LinkByText/LinkByText.client';
import type { LinkBoxType } from './types';

export const LinkBoxCaption = ({ data, link }: { data: LinkBoxType; link: string }) => {
  const {
    field_button_text: buttonText,
    behavior_paragraph_cta_icon: buttonIcon,
    behavior_paragraph_link_target: linkTarget,
  } = data;
  return (
    buttonText && (
      <LinkByText
        noUnderline
        data={{
          ...data,
          type: 'link_by_text',
          field_link_target: linkTarget,
          field_link: link,
          field_text: buttonText,
          field_icon: buttonIcon ? 'ArrowRight' : undefined,
        }}
        className={
          // svg stuff is needed to vertically align the text to the optional icon
          'mt-[0.125rem] w-full font-semibold [&&]:[&_svg]:relative! [&&]:[&_svg]:mt-[-0.05rem]!'
        }
      />
    )
  );
};
